import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';

import '@effectivastudio/lit-components/components/icon/element.js';

import style from './style.lit.css';

/**
 * Component for wrapping content with functionality to scroll to specific element and remove itself from the DOM
 *
 * @prop anchorUrl - For scrolling to specific element when action box clicked
 * @prop removeSelf - If true, renders button for removing the component from the DOM (optional)
 *
 * @slot default - For action box content
 */

export default class ActionBox extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    anchorUrl: { type: String },
    removeSelf: { type: Boolean },
  };

  /** @internal */
  get target() {
    return document.querySelector(this.anchorUrl);
  }

  /** @internal */
  get reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  handleAnchorClick(e) {
    e.preventDefault();

    if (this.target) {
      this.target.scrollIntoView({
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    } else {
      return;
    }
  }

  render() {
    return html`
      ${this.removeSelf
        ? html`<button @click=${this.remove} type="button" aria-label="dismiss">
            <ef-icon name="close"></ef-icon>
          </button>`
        : null}

      <slot></slot>

      <button
        href=${ifDefined(this.anchorUrl)}
        @click=${this.handleAnchorClick}
        class="scroll"
        aria-label="scroll to anchor">
        <ef-icon name="angle-down"></ef-icon>
      </button>
    `;
  }
}

customElements.get('xs-action-box') ||
  customElements.define('xs-action-box', ActionBox);
